import HttpService from '../../../../../../../services/rest/HttpService';

export const contentDataSearch = (type: string, search: string, header: any) =>
	HttpService.get(`/v2/${type === 'video' ? 'videos' : 'galleries'}/search?page=0&query=${search}`, null, header);

export const contentDataRequest = (type: string, id: string, header: any) =>
	HttpService.get(`/${type === 'video' ? 'videos' : 'galleries'}/${id}`, null, header);
